import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import axios from "./plugins/axios";
import VueAxios from "vue-axios";
import Toasted from "vue-toasted";
import VueLazyload from "vue-lazyload";
import errorHandler from "./plugins/stackdriver";

//import VueCookies from "vue-cookies";
import store from "./store";

// router setup
import router from "./routes/router.js";

import VueGtag from "vue-gtag";

import VueFacebookPixel from "vue-analytics-facebook-pixel";

Vue.use(VueFacebookPixel);
Vue.use(Toasted);

// TODO: Show a 'loading' symbol when loading
Vue.use(VueLazyload);

Vue.use(
  VueGtag,
  {
    config: { id: "UA-165826293-1" },
    disableScriptLoad: true
  },
  router
);

Vue.analytics.fbq.init("2012712782205715");

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(require("vue-moment"));

Vue.prototype.$api = `${process.env.VUE_APP_API_HOSTNAME}:${process.env.VUE_APP_API_PORT}`;

Vue.prototype.errorHandler = errorHandler;

Vue.prototype.isMobile = window.innerWidth <= 576;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  axios,
  store,

  router
});
